if (!customElements.get('himalayan-reference-header')) {
  customElements.define('himalayan-reference-header', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const signal = this.abort.signal;
      document.addEventListener('shopify:cart:lines-update', (event) => {
        event.promise?.then(({ cart, detail }) => {
          if (!this.isConnected) return;
          const count = cart?.totalQuantity ?? detail?.itemCount;
          const link = this.querySelector('[data-cart-label]');
          if (!link || !Number.isFinite(count)) return;
          const label = link.dataset.cartLabel.replace('__count__', String(count));
          link.setAttribute('aria-label', label);
          const text = link.querySelector('span');
          if (text) text.textContent = label;
        }).catch((error) => {
          if (error?.name !== 'AbortError') console.warn('[reference-header] Cart update failed:', error);
        });
      }, { signal });
      this.triggers = [...this.querySelectorAll('[data-menu]')];
      this.wrap = this.querySelector('.megawrap');
      this.triggers.forEach((trigger) => {
        trigger.addEventListener('pointerenter', (event) => {
          if (event.pointerType === 'mouse') this.openMenu(trigger);
        }, { signal });
        trigger.addEventListener('focus', () => {
          if (trigger.matches(':focus-visible')) this.openMenu(trigger);
        }, { signal });
        trigger.addEventListener('click', (event) => {
          if (this.openTrigger !== trigger) {
            event.preventDefault();
            this.openMenu(trigger);
          }
        }, { signal });
        trigger.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowDown') {
            event.preventDefault();
            this.openMenu(trigger);
            this.openPanel?.querySelector('a[href]')?.focus();
          }
        }, { signal });
      });
      this.wrap?.addEventListener('pointerleave', (event) => {
        if (event.pointerType === 'mouse') this.closeTimer = setTimeout(() => this.closeMenu(), 140);
      }, { signal });
      this.wrap?.addEventListener('pointerenter', () => clearTimeout(this.closeTimer), { signal });
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) this.closeMenu();
      }, { signal });
      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) this.closeMenu();
      }, { signal });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.openTrigger) {
          const trigger = this.openTrigger;
          this.closeMenu();
          trigger.focus({ preventScroll: true });
          this.closeMenu();
        }
      }, { signal });
      this.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-native-search], [data-native-cart]');
        if (!trigger || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
        const target = document.querySelector(trigger.hasAttribute('data-native-search') ? '#search-modal' : '#cart-drawer');
        const method = trigger.hasAttribute('data-native-search') ? 'showDialog' : 'open';
        if (typeof target?.[method] === 'function') {
          event.preventDefault();
          target[method]();
        }
      }, { signal });
      this.resizeObserver = new ResizeObserver(() => this.measure());
      this.resizeObserver.observe(this);
      if (this.wrap) this.resizeObserver.observe(this.wrap);
      window.addEventListener('resize', () => this.measure(), { signal, passive: true });
      if (this.dataset.variant !== 'finder') {
        document.addEventListener('scroll', () => {
          const owner = this.closest('.page-wrapper');
          const y = Math.max(window.scrollY, owner?.scrollTop || 0);
          this.querySelector('.rtop')?.classList.toggle('is-stuck', y > 40);
        }, { signal, passive: true, capture: true });
      }
      this.measure();
    }
    openMenu(trigger) {
      clearTimeout(this.closeTimer);
      if (this.openTrigger === trigger) return;
      this.closeMenu();
      this.openPanel = document.getElementById(trigger.dataset.menu);
      if (!this.openPanel) return;
      this.openTrigger = trigger;
      this.openPanel.setAttribute('data-open', '');
      trigger.setAttribute('aria-expanded', 'true');
    }
    closeMenu() {
      clearTimeout(this.closeTimer);
      this.openPanel?.removeAttribute('data-open');
      this.openTrigger?.setAttribute('aria-expanded', 'false');
      this.openPanel = null;
      this.openTrigger = null;
    }
    measure() {
      const group = this.closest('#header-group');
      if (this.dataset.variant === 'finder') this.querySelector('.rtop').style.width = `${this.clientWidth}px`;
      const height = this.getBoundingClientRect().height;
      document.body.style.setProperty('--header-height', `${height}px`);
      document.body.style.setProperty('--header-group-height', `${group?.getBoundingClientRect().height || height}px`);
      document.body.style.setProperty('--headh', `${height}px`);
      document.body.style.setProperty('--barh', `${this.querySelector('.topbar')?.getBoundingClientRect().height || 0}px`);
      document.body.style.setProperty('--transparent-header-offset-boolean', '0');
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resizeObserver?.disconnect();
      clearTimeout(this.closeTimer);
    }
  });
}
